import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Box,
  Card,
  Typography,
  Button,
  FormControl,
  TextField,
  MenuItem,
  Select,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  CircularProgress
} from "@mui/material";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "bootstrap/dist/css/bootstrap.min.css";
import PDF from "../../assets/Images/PDF.svg";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import axios from "axios";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { StaticDateTimePicker } from "@mui/x-date-pickers/StaticDateTimePicker";
import CloseIcon from "@mui/icons-material/Close";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { useSnackbar } from "../SnackbarContext";
import GlobalVariable from "../../services/Global";

// Extend dayjs with required plugins
dayjs.extend(utc);
dayjs.extend(timezone);

const baseApiUrl = GlobalVariable.BASE_API_URL;

const customTheme = createTheme({
  palette: {
    primary: {
      main: "#1976d2",
    },
  },
});

const statusOptions = [
  { value: 1, label: "New" },
  { value: 4, label: "Submitted" },
  { value: 3, label: "On-Hold" },
  { value: 2, label: "In-Progress" },
];

const submissionModes = [
  { value: "Portal", label: "Portal" },
  { value: "Email", label: "Email" },
  { value: "Physical", label: "Physical" },
];

export default function ExtrctedPdfDocument() {
  const [errors, setErrors] = useState({
    rfpIssuer: "",
    rfpType: "",
    location: "",
    budgetRange: "",
    expectedTimeline: "",
    website: "",
    name: "",
    email: "",
    conferenceDate: "",
    conferenceInformation: "",
    questionnaireDate: "",
    status: "",
    submissionMode: "",
    submissionDate: "",
    // remarks: '',
  });
  const [formData, setFormData] = useState({
    firstReview: "",
    rfpIssuer: "",
    rfpType: "",
    location: "",
    budgetRange: "",
    expectedTimeline: "",
    website: "",
    name: "",
    email: "",
    conferenceDate: "",
    conferenceInformation: "",
    questionnaireDate: "",
    status: "",
    submissionMode: "",
    submissionDate: "",
    internalPocName: "",
    additionalStatus: "",
    timezone: "Asia/Kolkata", // Add timezone field
    // remarks: '',
    filename: "",
  });
  const location = useLocation();
  const navigate = useNavigate();
  const { showSnackbar } = useSnackbar();
  const { pdfText } = location.state;
  const [isFormValid, setIsFormValid] = useState(false);
  const [loading, setLoading] = useState(false);
  const [comments, setComments] = useState("");
  const [firstReviewDialogOpen, setfirstReviewDialogOpen] = useState(false);
  const [conferenceDialogOpen, setConferenceDialogOpen] = useState(false);
  const [QuestionnaireDialogOpen, setQuestionnaireDialogOpen] = useState(false);
  const [submissionDialogOpen, setSubmissionDialogOpen] = useState(false);

  // Timezone configuration
  const timezones = [
    { value: 'America/New_York', label: 'Eastern Time (ET)', abbreviation: 'ET' },
    { value: 'America/Chicago', label: 'Central Time (CT)', abbreviation: 'CT' },
    { value: 'America/Denver', label: 'Mountain Time (MT)', abbreviation: 'MT' },
    { value: 'America/Los_Angeles', label: 'Pacific Time (PT)', abbreviation: 'PT' },
    { value: 'Europe/London', label: 'Greenwich Mean Time (GMT)', abbreviation: 'GMT' },
    { value: 'Europe/Paris', label: 'Central European Time (CET)', abbreviation: 'CET' },
    { value: 'Asia/Kolkata', label: 'India Standard Time (IST)', abbreviation: 'IST' },
    { value: 'Asia/Singapore', label: 'Singapore Time (SGT)', abbreviation: 'SGT' }
  ];

  const [selectedTimezone, setSelectedTimezone] = useState('Asia/Kolkata');

  const formatDateTime = (date) => {
    if (!date) return "";

    // If date already contains timezone info, extract just the date part
    if (typeof date === 'string' && date.includes('(')) {
      const datePart = date.split(' (')[0];
      return datePart;
    }

    // Otherwise format with timezone but return only the date part
    return dayjs.tz(date, selectedTimezone).format('YYYY-MM-DD HH:mm');
  };

  useEffect(() => {

    if (pdfText && pdfText.details) {
      let website = pdfText.details.website;
      if (website) {
        try {
          let url = new URL(website);
          website = url.origin;
        } catch (error) {
          console.error("Invalid website URL:", error);
        }
      }
      setFormData({
        firstReview:
          pdfText.details?.first_review === ""
            ? ""
            : formatDateTime(pdfText.details?.first_review),
        rfpIssuer: pdfText.details?.rfp_issuer || "",
        rfpType: pdfText.details?.rfp_type || "",
        location: pdfText.details?.location || "",
        budgetRange: pdfText.details?.budget_range || "",
        expectedTimeline: pdfText.details?.expected_timeline || "",
        website: website,
        name: pdfText.details?.contact_name || "",
        email: pdfText.details?.contact_email || "",
        conferenceDate:
          pdfText.details?.conference_date === null ||
            pdfText.details?.conference_date === ""
            ? ""
            : formatDateTime(pdfText.details?.conference_date),
        conferenceInformation:
          pdfText.details?.conference_information === ""
            ? "No information"
            : pdfText.details?.conference_information,
        questionnaireDate:
          pdfText.details?.questionnaire_date === null ||
            pdfText.details?.questionnaire_date === ""
            ? ""
            : formatDateTime(pdfText.details?.questionnaire_date),
        status: pdfText.details?.status || "",
        submissionMode: pdfText.details?.submission_mode || "",
        submissionDate:
          pdfText.details?.submission_date === "" ||
            pdfText.details?.submission_date === null
            ? ""
            : formatDateTime(pdfText.details?.submission_date),
        // remarks: pdfText.remarks?.remarks || '',
        filename: pdfText.filename,
      });
      setComments(pdfText?.comments?.comments || "")
    }
  }, [pdfText]);

  useEffect(() => {
    const checkFormValidity = () => {
      const allFieldsValid = Object.values(errors).every((error) => !error);
      const allRequiredFieldsFilled = Object.entries(formData).every(([key, value]) => {
        if (["conferenceDate", "conferenceInformation", "questionnaireDate", "budgetRange", "expectedTimeline", "firstReview", "internalPocName", "additionalStatus", "email", "name"].includes(key)) {
          return true;
        }
        if (typeof value === "string") {
          return value.trim() !== "";
        } else if (typeof value === "number") {
          return value !== null && value !== undefined;
        } else {
          return value !== null && value !== undefined;
        }
      });

      setIsFormValid(allFieldsValid && allRequiredFieldsFilled);
    };

    checkFormValidity();
  }, [formData, errors]);

  useEffect(() => {
    if (formData.firstReview) {
      setSelectedFirstReviewDate(dayjs(formData.firstReview));
    }
    if (formData.conferenceDate) {
      setSelectedConferenceDate(dayjs(formData.conferenceDate));
    }
    if (formData.questionnaireDate) {
      setSelectedQuestionnaireDate(dayjs(formData.questionnaireDate));
    }
    if (formData.submissionDate) {
      setSelectedSubmissionDate(dayjs(formData.submissionDate));
    }
  }, [formData.firstReview, formData.conferenceDate, formData.questionnaireDate, formData.submissionDate]);

  const [selectedFirstReviewDate, setSelectedFirstReviewDate] = useState(
    formData.firstReview ? dayjs(formData.firstReview) : null
  );
  const [selectedConferenceDate, setSelectedConferenceDate] = useState(
    formData.conferenceDate ? dayjs(formData.conferenceDate) : null
  );
  const [selectedQuestionnaireDate, setSelectedQuestionnaireDate] = useState(
    formData.questionnaireDate ? dayjs(formData.questionnaireDate) : null
  );
  const [selectedSubmissionDate, setSelectedSubmissionDate] = useState(
    formData.submissionDate ? dayjs(formData.submissionDate) : null
  );

  const firstReviewTheme = createTheme({
    components: {
      MuiPickersDay: {
        styleOverrides: {
          root: {
            ...(selectedFirstReviewDate === null && {
              '&.MuiPickersDay-today': {
                border: '2px solid #3e3f3fff',
                backgroundColor: '#fff',
                color: '#3e3f3fff',
                boxShadow: 'none',
                outline: 'none',
              },
            }),
            ...(selectedFirstReviewDate !== null && {
              '&.MuiPickersDay-today': {
                border: 'none',
                boxShadow: 'none',
                outline: 'none',
              },
              '&.Mui-selected': {
                border: '2px solid #3e3f3fff',
                backgroundColor: '#fff',
                color: '#3e3f3fff',
                boxShadow: 'none',
                outline: 'none',
              },
              '&.Mui-selected:focus': {
                border: '2px solid #3e3f3fff',
                backgroundColor: '#fff',
                color: '#3e3f3fff',
                boxShadow: 'none',
                outline: 'none',
              },
              '&.Mui-selected:hover': {
                border: '2px solid #3e3f3fff',
                backgroundColor: '#fff',
                color: '#3e3f3fff',
                boxShadow: 'none',
                outline: 'none',
              },
            }),
          },
        },
      },
    },
  });

  const conferenceTheme = createTheme({
    components: {
      MuiPickersDay: {
        styleOverrides: {
          root: {
            ...(selectedConferenceDate === null && {
              '&.MuiPickersDay-today': {
                border: '2px solid #3e3f3fff',
                backgroundColor: '#fff',
                color: '#3e3f3fff',
                boxShadow: 'none',
                outline: 'none',
              },
            }),
            ...(selectedConferenceDate !== null && {
              '&.MuiPickersDay-today': {
                border: 'none',
                boxShadow: 'none',
                outline: 'none',
              },
              '&.Mui-selected': {
                border: '2px solid #3e3f3fff',
                backgroundColor: '#fff',
                color: '#3e3f3fff',
                boxShadow: 'none',
                outline: 'none',
              },
              '&.Mui-selected:focus': {
                border: '2px solid #3e3f3fff',
                backgroundColor: '#fff',
                color: '#3e3f3fff',
                boxShadow: 'none',
                outline: 'none',
              },
              '&.Mui-selected:hover': {
                border: '2px solid #3e3f3fff',
                backgroundColor: '#fff',
                color: '#3e3f3fff',
                boxShadow: 'none',
                outline: 'none',
              },
            }),
          },
        },
      },
    },
  });

  const questionnaireTheme = createTheme({
    components: {
      MuiPickersDay: {
        styleOverrides: {
          root: {
            ...(selectedQuestionnaireDate === null && {
              '&.MuiPickersDay-today': {
                border: '2px solid #3e3f3fff',
                backgroundColor: '#fff',
                color: '#3e3f3fff',
                boxShadow: 'none',
                outline: 'none',
              },
            }),
            ...(selectedQuestionnaireDate !== null && {
              '&.MuiPickersDay-today': {
                border: 'none',
                boxShadow: 'none',
                outline: 'none',
              },
              '&.Mui-selected': {
                border: '2px solid #3e3f3fff',
                backgroundColor: '#fff',
                color: '#3e3f3fff',
                boxShadow: 'none',
                outline: 'none',
              },
              '&.Mui-selected:focus': {
                border: '2px solid #3e3f3fff',
                backgroundColor: '#fff',
                color: '#3e3f3fff',
                boxShadow: 'none',
                outline: 'none',
              },
              '&.Mui-selected:hover': {
                border: '2px solid #3e3f3fff',
                backgroundColor: '#fff',
                color: '#3e3f3fff',
                boxShadow: 'none',
                outline: 'none',
              },
            }),
          },
        },
      },
    },
  });

  const submissionTheme = createTheme({
    components: {
      MuiPickersDay: {
        styleOverrides: {
          root: {
            ...(selectedSubmissionDate === null && {
              '&.MuiPickersDay-today': {
                border: '2px solid #3e3f3fff',
                backgroundColor: '#fff',
                color: '#3e3f3fff',
                boxShadow: 'none',
                outline: 'none',
              },
            }),
            ...(selectedSubmissionDate !== null && {
              '&.MuiPickersDay-today': {
                border: 'none',
                boxShadow: 'none',
                outline: 'none',
              },
              '&.Mui-selected': {
                border: '2px solid #3e3f3fff',
                backgroundColor: '#fff',
                color: '#3e3f3fff',
                boxShadow: 'none',
                outline: 'none',
              },
              '&.Mui-selected:focus': {
                border: '2px solid #3e3f3fff',
                backgroundColor: '#fff',
                color: '#3e3f3fff',
                boxShadow: 'none',
                outline: 'none',
              },
              '&.Mui-selected:hover': {
                border: '2px solid #3e3f3fff',
                backgroundColor: '#fff',
                color: '#3e3f3fff',
                boxShadow: 'none',
                outline: 'none',
              },
            }),
          },
        },
      },
    },
  });


  const validateField = (name, value) => {
    switch (name) {
      case "budgetRange":
        return value === "" || /^[0-9]+$/.test(value) ? "" : "Budget Range must be a number";
      case "website":
        return /^(https?:\/\/)?(www\.)?[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+(\/.*)?$/.test(value)
          ? ""
          : "Invalid website URL";
      case "submissionMode":
        return value ? "" : "Submission mode is required";
      case "status":
        return value ? "" : "Status is required";
      case "rfpIssuer":
        return value ? "" : "RFP Issuer is required";
      case "rfpType":
        return value ? "" : "RFP Type is required";
      case "location":
        return value ? "" : "Location is required";
      case "submissionDate":
        return value ? "" : "Date is required";
      case "firstReview":
        return "";
      case "expectedTimeline":
        return "";
      case "conferenceInformation":
        return "";
      case "conferenceDate":
        return "";
      case "questionnaireDate":
        return "";
      case "internalPocName":
      case "additionalStatus":
        return "";
      default:
        return "";
    }
  };

  const handleSave = async () => {
    if (!isFormValid) return;
    let hasErrors = false;
    const newErrors = {};

    for (const [key, value] of Object.entries(formData)) {
      const error = validateField(key, value);
      if (error) {
        newErrors[key] = error;
        hasErrors = true;
      }
    }

    setErrors(newErrors);
    setLoading(true);


    if (hasErrors) return;
    const storedData = JSON.parse(localStorage.getItem("userDetails"));
    const userId = storedData?.userDetails?.id;

    if (!userId) {
      console.error("User ID not found in local storage");
      navigate("/404");
      return;
    }

    // Get timezone abbreviation for the selected timezone
    const tzAbbreviation = timezones.find(tz => tz.value === selectedTimezone)?.abbreviation || "IST";

    // Extract filenames from selectedFiles for rfp_files array

    // Handle different possible data structures
    let rfpFiles = [];
    if (pdfText?.selectedFiles && Array.isArray(pdfText.selectedFiles) && pdfText.selectedFiles.length > 0) {
      rfpFiles = pdfText.selectedFiles.map(file => file.filename || file.name || file);
    } else if (pdfText?.allFiles && Array.isArray(pdfText.allFiles) && pdfText.allFiles.length > 0) {
      // Fallback to allFiles if selectedFiles is not available
      rfpFiles = pdfText.allFiles.map(file => file.filename || file.name || file);
    } else if (pdfText?.files && Array.isArray(pdfText.files) && pdfText.files.length > 0) {
      // Another fallback to files array
      rfpFiles = pdfText.files.map(file => file.filename || file.name || file);
    } else if (formData.filename) {
      // If no arrays are available, use the single filename from formData
      rfpFiles = [formData.filename];
    } else if (pdfText?.filename) {
      // Fallback to pdfText.filename
      rfpFiles = [pdfText.filename];
    }

    const data = {
      details: {
        userid: userId,
        first_review: formData?.firstReview ? formatDateTime(formData?.firstReview) : "",
        first_review_date_timezone: formData?.firstReview ? tzAbbreviation : "",
        rfp_issuer: formData.rfpIssuer,
        rfp_type: formData.rfpType,
        location: formData.location,
        budget_range: formData.budgetRange,
        expected_timeline: formData.expectedTimeline,
        website: formData.website,
        contact_name: formData.name || "NA",
        contact_email: formData.email || "NA",
        conference_date: formData.conferenceDate ? formatDateTime(formData?.conferenceDate) : "",
        conference_date_timezone: formData.conferenceDate ? tzAbbreviation : "",
        conference_information: formData.conferenceInformation || "",
        questionnaire_date: formData.questionnaireDate ? formatDateTime(formData?.questionnaireDate) : "",
        questionnaire_date_timezone: formData.questionnaireDate ? tzAbbreviation : "",
        submission_mode: formData.submissionMode,
        submission_date: formatDateTime(formData?.submissionDate),
        submission_date_timezone: formData?.submissionDate ? tzAbbreviation : "",
        status: formData.status,
        conference_reason: "",
        questionnaire_reason: "",
        internal_poc_name: formData.internalPocName || "",
        additional_status: formData.additionalStatus || "",
      },
      remarks: {
        userid: userId,
        remarks: "",
      },
      comments: {
        userid: userId,
        comments: comments,
      },
      filename: formData.filename,
      rfp_files: rfpFiles,
      // Include file arrays from the uploaded files
      allFiles: pdfText?.allFiles || [],
      selectedFiles: pdfText?.selectedFiles || [],
      mulitple_files: []
    };

    axios
      .post(`${baseApiUrl}/dashboard/addrfp`,
        data
      )
      .then((response) => {
        showSnackbar("RFP added successfully.", "success");
        navigate("/dashboard");
        setLoading(false);
      })
      .catch((error) => {
        console.error("There was an error saving the RFP:", error);
        navigate("/404");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    const error = validateField(name, value);
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: error,
    }));
  };

  const handleRfpCancel = () => {
    navigate("/dashboard");
  };

  // Global timezone change handler that updates all fields and converts existing dates
  const handleGlobalTimezoneChange = (newTimezone) => {
    setSelectedTimezone(newTimezone);

    // Convert existing dates to the new timezone
    setFormData(prevData => {
      const newData = { ...prevData, timezone: newTimezone };

      // Helper function to convert a date string to new timezone
      const convertDateToNewTimezone = (dateString) => {
        if (!dateString) return dateString;

        try {
          // If date already has timezone info, extract the date part
          let datePart = dateString;
          let originalTimezone = selectedTimezone; // Default to current timezone

          if (dateString.includes('(')) {
            datePart = dateString.split(' (')[0];
            // Try to find the original timezone from the abbreviation
            const abbreviation = dateString.split(' (')[1].replace(')', '');

            // Handle corrupted abbreviations by mapping common corruptions
            const abbreviationMap = {
              'G9T': 'GMT',
              'G10T': 'GMT',
              '9T': 'MT',
              '10T': 'PT',
              'E9T': 'ET',
              'C9T': 'CT'
            };

            const cleanAbbreviation = abbreviationMap[abbreviation] || abbreviation;
            const foundTimezone = timezones.find(tz => tz.abbreviation === cleanAbbreviation);

            if (foundTimezone) {
              originalTimezone = foundTimezone.value;
            }
          }

          // Parse the date in the original timezone context
          const originalDate = dayjs.tz(datePart, 'YYYY-MM-DD HH:mm', originalTimezone);

          // Convert to the new timezone
          const convertedDate = originalDate.tz(newTimezone);
          const newTimezoneAbbreviation = timezones.find(tz => tz.value === newTimezone)?.abbreviation;

          // Ensure we have a valid abbreviation
          if (!newTimezoneAbbreviation) {
            console.error('No timezone abbreviation found for:', newTimezone);
            return dateString; // Return original if we can't find abbreviation
          }

          // Clean the abbreviation to ensure no corruption
          const cleanAbbreviation = newTimezoneAbbreviation.trim().replace(/[^\w]/g, '');

          // Format the result manually to avoid corruption
          const formattedDate = convertedDate.format('YYYY-MM-DD HH:mm');
          const result = `${formattedDate} (${cleanAbbreviation})`;

          return result;
        } catch (error) {
          return dateString; // Return original if conversion fails
        }
      };

      // Convert all date fields
      if (prevData.firstReview) {
        newData.firstReview = convertDateToNewTimezone(prevData.firstReview);
      }
      if (prevData.conferenceDate) {
        newData.conferenceDate = convertDateToNewTimezone(prevData.conferenceDate);
      }
      if (prevData.questionnaireDate) {
        newData.questionnaireDate = convertDateToNewTimezone(prevData.questionnaireDate);
      }
      if (prevData.submissionDate) {
        newData.submissionDate = convertDateToNewTimezone(prevData.submissionDate);
      }

      return newData;
    });
  };

  // Individual timezone change handlers that call the global handler
  const handleFirstReviewTimezoneChange = (newTimezone) => {
    handleGlobalTimezoneChange(newTimezone);
  };

  const handleConferenceTimezoneChange = (newTimezone) => {
    handleGlobalTimezoneChange(newTimezone);
  };

  const handleQuestionnaireTimezoneChange = (newTimezone) => {
    handleGlobalTimezoneChange(newTimezone);
  };

  const handleSubmissionTimezoneChange = (newTimezone) => {
    handleGlobalTimezoneChange(newTimezone);
  };

  const handleDateReviewAccept = (newValue) => {
    if (newValue) {
      const selectedTimezoneAbbreviation = timezones.find(tz => tz.value === selectedTimezone)?.abbreviation;

      // Ensure we have a valid abbreviation
      if (!selectedTimezoneAbbreviation) {
        return;
      }

      // Clean the abbreviation to ensure no corruption
      const cleanAbbreviation = selectedTimezoneAbbreviation.trim().replace(/[^\w]/g, '');

      // Format the date in the selected timezone context
      const datePart = dayjs.tz(newValue, selectedTimezone).format('YYYY-MM-DD HH:mm');
      const formattedDate = `${datePart} (${cleanAbbreviation})`;

      handleInputChange({
        target: {
          name: "firstReview",
          value: formattedDate,
        },
      });
      setSelectedFirstReviewDate(newValue);
    }
    setfirstReviewDialogOpen(false);
  };

  const handleConferenceDateAccept = (newValue) => {
    if (newValue) {
      const selectedTimezoneAbbreviation = timezones.find(tz => tz.value === selectedTimezone)?.abbreviation;

      // Ensure we have a valid abbreviation
      if (!selectedTimezoneAbbreviation) {
        return;
      }

      // Clean the abbreviation to ensure no corruption
      const cleanAbbreviation = selectedTimezoneAbbreviation.trim().replace(/[^\w]/g, '');

      // Format the date in the selected timezone context
      const datePart = dayjs.tz(newValue, selectedTimezone).format('YYYY-MM-DD HH:mm');
      const formattedDate = `${datePart} (${cleanAbbreviation})`;

      handleInputChange({
        target: {
          name: "conferenceDate",
          value: formattedDate,
        },
      });
      setSelectedConferenceDate(newValue);
    }
    setConferenceDialogOpen(false);
  };

  const handleQuestionnaireDateAccept = (newValue) => {
    if (newValue) {
      const selectedTimezoneAbbreviation = timezones.find(tz => tz.value === selectedTimezone)?.abbreviation;

      // Ensure we have a valid abbreviation
      if (!selectedTimezoneAbbreviation) {
        return;
      }

      // Clean the abbreviation to ensure no corruption
      const cleanAbbreviation = selectedTimezoneAbbreviation.trim().replace(/[^\w]/g, '');

      // Format the date in the selected timezone context
      const datePart = dayjs.tz(newValue, selectedTimezone).format('YYYY-MM-DD HH:mm');
      const formattedDate = `${datePart} (${cleanAbbreviation})`;

      handleInputChange({
        target: {
          name: "questionnaireDate",
          value: formattedDate,
        },
      });
      setSelectedQuestionnaireDate(newValue);
    }
    setQuestionnaireDialogOpen(false);
  };

  const handleSubmissionDateAccept = (newValue) => {
    if (newValue) {
      const selectedTimezoneAbbreviation = timezones.find(tz => tz.value === selectedTimezone)?.abbreviation;

      // Ensure we have a valid abbreviation
      if (!selectedTimezoneAbbreviation) {
        return;
      }

      // Clean the abbreviation to ensure no corruption
      const cleanAbbreviation = selectedTimezoneAbbreviation.trim().replace(/[^\w]/g, '');

      // Format the date in the selected timezone context
      const datePart = dayjs.tz(newValue, selectedTimezone).format('YYYY-MM-DD HH:mm');
      const formattedDate = `${datePart} (${cleanAbbreviation})`;

      handleInputChange({
        target: {
          name: "submissionDate",
          value: formattedDate,
        },
      });
      setSelectedSubmissionDate(newValue);
    }
    setSubmissionDialogOpen(false);
  };


  return (
    <Container fluid className="ps-3 mt-2 rfpDtailsContainer">
      {loading && (
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            zIndex: 1000,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <CircularProgress className=' text-primary' />
          <Typography variant="h6" className="text-primary" sx={{ mt: 2 }}>Analyzing RFP...</Typography>
        </Box>
      )}
      <Card className="rounded-3">
        <Box style={{ paddingBottom: "16px" }}>
          <div style={{ padding: "16px 0" }}>
            <Row className="mb-2 align-items-center mx-1">
              <Col xs={12} sm={6} md={6}>
                <Box display="flex" alignItems="center">
                  <IconButton>
                    <img src={PDF} alt="pdf" width="25px" height="25px" />
                  </IconButton>
                  <span
                    className="extractedPdfName"
                    style={{
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                    }}
                  >
                    {(pdfText && pdfText.filename) || "MicrosoftRFP.pdf"}
                  </span>
                </Box>
              </Col>
              <Col
                xs={12}
                sm={6}
                md={6}
                className=" d-flex justify-content-end"
              >
                <Button
                  className="border-primary text-primary text-capitalize rounded-2 "
                  variant="outlined"
                  color="primary"
                  onClick={handleRfpCancel}
                  disabled={loading}
                >
                  Back
                </Button>
              </Col>
            </Row>
          </div>
          <form style={{ marginLeft: "15px", marginTop: "6px" }}>
            <Container fluid>

              <Box
                sx={{
                  border: "1px solid #ccc",
                  borderRadius: "10px",
                  padding: "16px",
                  position: "relative",
                  marginTop: "6px",
                }}
                className="mb-5"
              >
                <Typography
                  sx={{
                    position: "absolute",
                    top: "-10px",
                    left: "20px",
                    background: "#fff",
                    padding: "0 8px",
                    fontSize: "14px",
                  }}
                  className="fontstyleeb"
                >
                  RFP Details
                </Typography>
                <Row className="pb-2">
                  <Col lg={3} md={6} sm={12}>
                    <FormControl fullWidth margin="normal" className="mt-2 inputfields">
                      <Typography className="fontstyleet" variant="h6" gutterBottom>
                        First Review
                      </Typography>
                      <TextField
                        name="firstReview"
                        value={formatDateTime(formData.firstReview)}
                        placeholder="Select date"
                        disabled={loading}
                        InputProps={{
                          readOnly: true,
                          endAdornment: (
                            <IconButton
                              onClick={() => setfirstReviewDialogOpen(true)}
                              color="primary"
                              size="large"
                              disabled={loading}
                            >
                              <CalendarMonthIcon sx={{ color: "#0175FF" }} />
                            </IconButton>
                          ),
                        }}
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            borderRadius: "10px",
                          },
                          "& .MuiInputBase-root": {
                            height: "40px",
                          },
                        }}
                      />

                      <Dialog
                        open={firstReviewDialogOpen}
                        onClose={loading ? undefined : () => setfirstReviewDialogOpen(false)}
                        maxWidth="xs"
                        fullWidth
                        PaperProps={{
                          style: {
                            height: "85%",
                            width: "100%",
                            borderRadius: "12px",
                            position: "fixed",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            overflow: "auto",
                          },
                        }}
                      >
                        <DialogTitle>
                          Select First Review and Time
                          <Typography variant="subtitle2" sx={{ mt: 1, color: 'text.secondary' }}>
                            Selected Timezone: {timezones.find(tz => tz.value === selectedTimezone)?.label}
                          </Typography>
                          <Box sx={{ mt: 1 }}>
                            <FormControl fullWidth size="small">
                              <Select
                                value={selectedTimezone}
                                onChange={(e) => handleFirstReviewTimezoneChange(e.target.value)}
                                disabled={loading}
                                sx={{
                                  '& .MuiOutlinedInput-root': {
                                    borderRadius: '8px',
                                  },
                                }}
                              >
                                {timezones.map((timezone) => (
                                  <MenuItem key={timezone.value} value={timezone.value}>
                                    {timezone.label}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </Box>
                          <IconButton
                            edge="end"
                            color="inherit"
                            onClick={() => setfirstReviewDialogOpen(false)}
                            aria-label="close"
                            aria-hidden={false}
                            aria-modal={true}
                            disabled={loading}
                            sx={{
                              position: "absolute",
                              right: 9,
                              top: 8,
                              color: (theme) => theme.palette.grey[500],
                            }}
                          >
                            <CloseIcon />
                          </IconButton>
                        </DialogTitle>
                        <DialogContent>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <ThemeProvider theme={firstReviewTheme}>
                              <StaticDateTimePicker
                                value={selectedFirstReviewDate}
                                onAccept={(newValue) =>
                                  handleDateReviewAccept(newValue)
                                }
                                onClose={() => setfirstReviewDialogOpen(false)}
                                ampm={false}
                              />
                            </ThemeProvider>
                          </LocalizationProvider>
                        </DialogContent>
                      </Dialog>
                    </FormControl>
                  </Col>
                  <Col lg={6} md={6} sm={12}>
                    <FormControl fullWidth margin="normal" className="inputfields">
                      <Typography>RFP ISSUER<span style={{ color: "#ff0000" }}>*</span></Typography>
                      <TextField
                        placeholder="Issuer Name"
                        name="rfpIssuer"
                        autoComplete="off"
                        onChange={handleInputChange}
                        value={formData.rfpIssuer}
                        disabled={loading}
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            borderRadius: "10px",
                          },
                          "& .MuiInputBase-root": {
                            height: "40px",
                          },
                        }}
                      />
                      {errors.rfpIssuer && (
                        <Typography color="error">
                          {errors.rfpIssuer}
                        </Typography>
                      )}
                    </FormControl>
                  </Col>
                  <Col lg={3} md={12} sm={12}>
                    <FormControl fullWidth margin="normal" className="inputfields">
                      <Typography>Rfp Type<span style={{ color: "#ff0000" }}>*</span></Typography>
                      <Select
                        value={formData.rfpType}
                        onChange={handleInputChange}
                        name="rfpType"
                        disabled={loading}
                        sx={{
                          "& .MuiOutlinedInput-root": { borderRadius: "10px" },
                          "& .MuiOutlinedInput-notchedOutline": {
                            borderRadius: "10px",
                            height: "45px",
                          },
                          "& .MuiSelect-icon": { top: "8px", color: "blue" },
                          "& .MuiOutlinedInput-input": { paddingTop: "9px" },
                        }}
                      >
                        <MenuItem className="subheader" value="Solutioning">
                          Solutioning
                        </MenuItem>
                        <MenuItem className="subheader" value="Staffing">
                          Staffing
                        </MenuItem>
                      </Select>
                      {errors.rfpType && (
                        <Typography color="error">{errors.rfpType}</Typography>
                      )}
                    </FormControl>
                  </Col>
                </Row>
                <Row>
                  <Col lg={3} md={6} sm={12}>
                    <FormControl fullWidth margin="normal" className="inputfields">
                      <Typography>Location<span style={{ color: "#ff0000" }}>*</span></Typography>
                      <TextField
                        placeholder="Location"
                        name="location"
                        autoComplete="off"
                        value={formData.location}
                        disabled={loading}
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            borderRadius: "10px",
                          },
                          "& .MuiInputBase-root": {
                            height: "40px",
                          },
                        }}
                        onChange={handleInputChange}
                      />
                      {errors.location && (
                        <Typography color="error">{errors.location}</Typography>
                      )}
                    </FormControl>
                  </Col>
                  <Col lg={3} md={6} sm={12}>
                    <FormControl fullWidth margin="normal" className="inputfields">
                      <Typography>Budget Range($)</Typography>
                      <TextField
                        placeholder="Budget Range"
                        name="budgetRange"
                        autoComplete="off"
                        value={formData.budgetRange}
                        disabled={loading}
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            borderRadius: "10px",
                          },
                          "& .MuiInputBase-root": {
                            height: "40px",
                          },
                        }}
                        onChange={(e) => {
                          const value = e.target.value.replace(/[^0-9]/g, '');
                          setFormData((prevData) => ({
                            ...prevData,
                            budgetRange: value,
                          }));
                          const error = validateField("budgetRange", value);
                          setErrors((prevErrors) => ({
                            ...prevErrors,
                            budgetRange: error,
                          }));
                        }}
                        onKeyPress={(e) => {
                          if (!/[0-9]/.test(e.key) && !['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight'].includes(e.key)) {
                            e.preventDefault();
                          }
                        }}
                      />
                      {errors.budgetRange && (
                        <Typography color="error">
                          {errors.budgetRange}
                        </Typography>
                      )}
                    </FormControl>
                  </Col>
                  <Col lg={3} md={12} sm={12}>
                    <FormControl fullWidth margin="normal" className="inputfields">
                      <Typography>Expected Timeline(In months)</Typography>
                      <TextField
                        placeholder="Expected Timeline"
                        name="expectedTimeline"
                        autoComplete="off"
                        value={formData.expectedTimeline}
                        disabled={loading}
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            borderRadius: "10px",
                          },
                          "& .MuiInputBase-root": {
                            height: "40px",
                          },
                        }}
                        onChange={handleInputChange}
                      />

                    </FormControl>
                  </Col>
                  <Col lg={3} md={12} sm={12} xs={12} className="inputfields">
                    <FormControl fullWidth margin="normal">
                      <Typography>Website<span style={{ color: "#ff0000" }}>*</span></Typography>
                      <TextField
                        placeholder="Website"
                        name="website"
                        autoComplete="off"
                        value={formData.website}
                        disabled={loading}
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            borderRadius: "10px",
                          },
                          "& .MuiInputBase-root": {
                            height: "40px",
                          },
                        }}
                        onChange={handleInputChange}
                      />
                      {errors.website && (
                        <Typography color="error">{errors.website}</Typography>
                      )}
                    </FormControl>
                  </Col>
                </Row>
              </Box>
              <Box
                sx={{
                  border: "1px solid #ccc",
                  borderRadius: "10px",
                  padding: "16px",

                  position: "relative",
                }}
                className="mb-5"
              >
                <Typography
                  sx={{
                    position: "absolute",
                    top: "-10px",
                    left: "20px",
                    background: "#fff",
                    padding: "0 8px",
                    fontSize: "14px",
                    fontWeight: "bold",
                  }}
                >
                  Point of Contact Details
                </Typography>
                <Row>
                  <Col lg={3}>
                    <FormControl fullWidth margin="normal" className="inputfields">
                      <Typography>Name</Typography>
                      <TextField
                        placeholder="Name"
                        name="name"
                        value={formData.name}
                        autoComplete="off"
                        disabled={loading}
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            borderRadius: "10px",
                          },
                          "& .MuiInputBase-root": {
                            height: "40px",
                          },
                        }}
                        onChange={handleInputChange}
                      />
                      {/* {errors.name && (
                        <Typography color="error">{errors.name}</Typography>
                      )} */}
                    </FormControl>
                  </Col>
                  <Col lg={3}>
                    <FormControl fullWidth margin="normal" className="inputfields">
                      <Typography>Email</Typography>
                      <TextField
                        placeholder="Email"
                        name="email"
                        value={formData.email}
                        autoComplete="off"
                        disabled={loading}
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            borderRadius: "10px",
                          },
                          "& .MuiInputBase-root": {
                            height: "40px",
                          },
                        }}
                        onChange={handleInputChange}
                      />
                      {/* {errors.email && (
                        <Typography color="error">{errors.email}</Typography>
                      )} */}
                    </FormControl>
                  </Col>
                </Row>
              </Box>
              <Box
                sx={{
                  border: "1px solid #ccc",
                  borderRadius: "10px",
                  padding: "16px",

                  position: "relative",
                }}
                className="mb-5"
              >
                <Typography
                  sx={{
                    position: "absolute",
                    top: "-10px",
                    left: "20px",
                    background: "#fff",
                    padding: "0 8px",
                    fontSize: "14px",
                    fontWeight: "bold",
                  }}
                >
                  Submission Details
                </Typography>
                <Row className="pb-2">
                  <Col lg={3} md={6} sm={12} xs={12}>
                    <FormControl fullWidth margin="normal" className="mt-2 inputfields">
                      <Typography
                        variant="h6"
                        className="fontstyleet"
                        gutterBottom
                      >
                        Conference Date
                      </Typography>
                      <TextField
                        name="conferenceDate"
                        value={formatDateTime(formData.conferenceDate)}
                        placeholder="Select date"
                        disabled={loading}
                        InputProps={{
                          readOnly: true,
                          endAdornment: (
                            <IconButton
                              onClick={() => setConferenceDialogOpen(true)}
                              color="primary"
                              size="large"
                              disabled={loading}
                            >
                              <CalendarMonthIcon sx={{ color: "#0175FF" }} />
                            </IconButton>
                          ),
                        }}
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            borderRadius: "10px",
                          },
                          "& .MuiInputBase-root": {
                            height: "40px",
                          },
                        }}
                      />
                      {errors.conferenceDate && (
                        <Typography color="error">
                          {errors.conferenceDate}
                        </Typography>
                      )}

                      <Dialog
                        open={conferenceDialogOpen}
                        onClose={loading ? undefined : () => setConferenceDialogOpen(false)}
                        maxWidth="xs"
                        fullWidth
                        PaperProps={{
                          style: {
                            height: "85%",
                            width: "100%",
                            borderRadius: "12px",
                            position: "fixed",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            overflow: "auto",

                          },
                        }}
                      >
                        <DialogTitle>
                          Select Conference Date and Time
                          <Typography variant="subtitle2" sx={{ mt: 1, color: 'text.secondary' }}>
                            Selected Timezone: {timezones.find(tz => tz.value === selectedTimezone)?.label}
                          </Typography>
                          <Box sx={{ mt: 1 }}>
                            <FormControl fullWidth size="small">
                              <Select
                                value={selectedTimezone}
                                onChange={(e) => handleConferenceTimezoneChange(e.target.value)}
                                disabled={loading}
                                sx={{
                                  '& .MuiOutlinedInput-root': {
                                    borderRadius: '8px',
                                  },
                                }}
                              >
                                {timezones.map((timezone) => (
                                  <MenuItem key={timezone.value} value={timezone.value}>
                                    {timezone.label}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </Box>
                          <IconButton
                            edge="end"
                            color="inherit"
                            onClick={() => setConferenceDialogOpen(false)}
                            aria-label="close"
                            disabled={loading}
                            sx={{
                              position: "absolute",
                              right: 9,
                              top: 8,
                              color: (theme) => theme.palette.grey[500],
                            }}
                          >
                            <CloseIcon />
                          </IconButton>
                        </DialogTitle>
                        <DialogContent>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <ThemeProvider theme={conferenceTheme}>
                              <StaticDateTimePicker
                                value={selectedConferenceDate}
                                onAccept={(newValue) =>
                                  handleConferenceDateAccept(newValue)
                                }
                                onClose={() => setConferenceDialogOpen(false)}
                                ampm={false}
                              />
                            </ThemeProvider>
                          </LocalizationProvider>
                        </DialogContent>
                      </Dialog>
                    </FormControl>
                  </Col>

                  <Col lg={3} md={6} sm={12} xs={12}>
                    <FormControl fullWidth margin="normal" className="mt-2 inputfields">
                      <Typography
                        variant="h6"
                        className="fontstyleet"
                        gutterBottom
                      >
                        Questionnaire Date
                      </Typography>
                      <TextField
                        name="questionnaireDate"
                        value={formatDateTime(formData.questionnaireDate)}
                        onChange={(e) => handleInputChange(e)}
                        placeholder="Select date"
                        disabled={loading}
                        InputProps={{
                          readOnly: true,
                          endAdornment: (
                            <IconButton
                              onClick={() => setQuestionnaireDialogOpen(true)}
                              color="primary"
                              size="large"
                              disabled={loading}
                            >
                              <CalendarMonthIcon sx={{ color: "#0175FF" }} />
                            </IconButton>
                          ),
                        }}
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            borderRadius: "10px",
                          },
                          "& .MuiInputBase-root": {
                            height: "40px",
                          },
                        }}
                      />
                      {errors.questionnaireDate && (
                        <Typography color="error">
                          {errors.questionnaireDate}
                        </Typography>
                      )}

                      <Dialog
                        open={QuestionnaireDialogOpen}
                        onClose={loading ? undefined : () => setQuestionnaireDialogOpen(false)}
                        maxWidth="xs"
                        fullWidth
                        PaperProps={{
                          style: {
                            height: "85%",
                            width: "100%",
                            borderRadius: "12px",
                            position: "fixed",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            overflow: "auto",
                          },
                        }}
                      >
                        <DialogTitle>
                          Select Questionnaire Date and Time
                          <Typography variant="subtitle2" sx={{ mt: 1, color: 'text.secondary' }}>
                            Selected Timezone: {timezones.find(tz => tz.value === selectedTimezone)?.label}
                          </Typography>
                          <Box sx={{ mt: 1 }}>
                            <FormControl fullWidth size="small">
                              <Select
                                value={selectedTimezone}
                                onChange={(e) => handleQuestionnaireTimezoneChange(e.target.value)}
                                disabled={loading}
                                sx={{
                                  '& .MuiOutlinedInput-root': {
                                    borderRadius: '8px',
                                  },
                                }}
                              >
                                {timezones.map((timezone) => (
                                  <MenuItem key={timezone.value} value={timezone.value}>
                                    {timezone.label}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </Box>
                          <IconButton
                            edge="end"
                            color="inherit"
                            onClick={() => setQuestionnaireDialogOpen(false)}
                            aria-label="close"
                            disabled={loading}
                            sx={{
                              position: "absolute",
                              right: 9,
                              top: 8,
                              color: (theme) => theme.palette.grey[500],
                            }}
                          >
                            <CloseIcon />
                          </IconButton>
                        </DialogTitle>
                        <DialogContent>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <ThemeProvider theme={questionnaireTheme}>
                              <StaticDateTimePicker
                                value={selectedQuestionnaireDate}
                                onAccept={(newValue) =>
                                  handleQuestionnaireDateAccept(newValue)
                                }
                                onClose={() => setQuestionnaireDialogOpen(false)}
                                ampm={false}
                              />
                            </ThemeProvider>
                          </LocalizationProvider>
                        </DialogContent>
                      </Dialog>
                    </FormControl>
                  </Col>
                  <Col lg={3} md={6} sm={12} xs={12}>
                    <FormControl fullWidth margin="normal" className="inputfields">
                      <Typography>Status<span style={{ color: "#ff0000" }}>*</span></Typography>
                      <Select
                        value={formData.status}
                        onChange={handleInputChange}
                        name="status"
                        disabled={loading}
                        sx={{
                          "& .MuiOutlinedInput-root": { borderRadius: "10px" },
                          "& .MuiOutlinedInput-notchedOutline": {
                            borderRadius: "10px",
                            height: "45px",
                          },
                          "& .MuiSelect-icon": { top: "8px", color: "blue" },
                          "& .MuiOutlinedInput-input": { paddingTop: "9px" },
                        }}
                      >
                        {statusOptions.map((option) => (
                          <MenuItem key={option.value} value={option.value}>
                            {option.label}
                          </MenuItem>
                        ))}
                      </Select>
                      {errors.status && (
                        <Typography color="error">{errors.status}</Typography>
                      )}
                    </FormControl>
                  </Col>
                  <Col lg={3} md={6} sm={12} xs={12}>
                    <FormControl fullWidth margin="normal" className="inputfields">
                      <Typography>Submission Mode<span style={{ color: "#ff0000" }}>*</span></Typography>
                      <Select
                        value={formData.submissionMode}
                        onChange={handleInputChange}
                        name="submissionMode"
                        disabled={loading}
                        sx={{
                          "& .MuiOutlinedInput-root": { borderRadius: "10px" },
                          "& .MuiOutlinedInput-notchedOutline": {
                            borderRadius: "10px",
                            height: "45px",
                          },
                          "& .MuiSelect-icon": { top: "8px", color: "blue" },
                          "& .MuiOutlinedInput-input": { paddingTop: "9px" },
                        }}
                      >
                        {submissionModes.map((option) => (
                          <MenuItem key={option.value} value={option.value}>
                            {option.label}
                          </MenuItem>
                        ))}
                      </Select>
                      {errors.submissionMode && (
                        <Typography color="error">
                          {errors.submissionMode}
                        </Typography>
                      )}
                    </FormControl>
                  </Col>
                </Row>
                <Row>

                  <Col lg={3} md={6} sm={12} xs={12}>
                    <FormControl fullWidth margin="normal" className="mt-2 inputfields">
                      <Typography
                        variant="h6"
                        className="fontstyleet"
                        gutterBottom
                      >
                        Submission Date<span style={{ color: "#ff0000" }}>*</span>
                      </Typography>
                      <TextField
                        name="submissionDate"
                        value={formatDateTime(formData.submissionDate)}
                        onChange={(e) => handleInputChange(e)}
                        placeholder="Select date"
                        disabled={loading}
                        InputProps={{
                          readOnly: true,
                          endAdornment: (
                            <IconButton
                              onClick={() => setSubmissionDialogOpen(true)}
                              color="primary"
                              size="large"
                              disabled={loading}
                            >
                              <CalendarMonthIcon sx={{ color: "#0175FF" }} />
                            </IconButton>
                          ),
                        }}
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            borderRadius: "10px",
                          },
                          "& .MuiInputBase-root": {
                            height: "40px",
                          },
                        }}
                      />
                      {errors.submissionDate && (
                        <Typography color="error">
                          {errors.submissionDate}
                        </Typography>
                      )}

                      <Dialog
                        open={submissionDialogOpen}
                        onClose={loading ? undefined : () => setSubmissionDialogOpen(false)}
                        maxWidth="xs"
                        fullWidth
                        PaperProps={{
                          style: {
                            height: "85%",
                            width: "100%",
                            borderRadius: "12px",
                            position: "fixed",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            overflow: "auto",
                          },
                        }}
                      >
                        <DialogTitle>
                          Select Submission Date and Time
                          <Typography variant="subtitle2" sx={{ mt: 1, color: 'text.secondary' }}>
                            Selected Timezone: {timezones.find(tz => tz.value === selectedTimezone)?.label}
                          </Typography>
                          <Box sx={{ mt: 1 }}>
                            <FormControl fullWidth size="small">
                              <Select
                                value={selectedTimezone}
                                onChange={(e) => handleSubmissionTimezoneChange(e.target.value)}
                                disabled={loading}
                                sx={{
                                  '& .MuiOutlinedInput-root': {
                                    borderRadius: '8px',
                                  },
                                }}
                              >
                                {timezones.map((timezone) => (
                                  <MenuItem key={timezone.value} value={timezone.value}>
                                    {timezone.label}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </Box>
                          <IconButton
                            edge="end"
                            color="inherit"
                            onClick={() => setSubmissionDialogOpen(false)}
                            aria-label="close"
                            disabled={loading}
                            sx={{
                              position: "absolute",
                              right: 9,
                              top: 8,
                              color: (theme) => theme.palette.grey[500],
                            }}
                          >
                            <CloseIcon />
                          </IconButton>
                        </DialogTitle>
                        <DialogContent>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <ThemeProvider theme={submissionTheme}>
                              <StaticDateTimePicker
                                value={selectedSubmissionDate}
                                onAccept={(newValue) =>
                                  handleSubmissionDateAccept(newValue)
                                }
                                onClose={() => setSubmissionDialogOpen(false)}
                                ampm={false}
                              />
                            </ThemeProvider>
                          </LocalizationProvider>
                        </DialogContent>
                      </Dialog>
                    </FormControl>
                  </Col>
                  <Col lg={3} md={6} sm={12} xs={12}>
                    <FormControl fullWidth margin="normal" className="inputfields">
                      <Typography>Internal POC Name</Typography>
                      <TextField
                        placeholder="Internal POC Name"
                        name="internalPocName"
                        value={formData.internalPocName}
                        autoComplete="off"
                        disabled={loading}
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            borderRadius: "10px",
                          },
                          "& .MuiInputBase-root": {
                            height: "40px",
                          },
                        }}
                        onChange={handleInputChange}
                      />
                    </FormControl>
                  </Col>
                  <Col lg={3} md={6} sm={12} xs={12}>
                    <FormControl fullWidth margin="normal" className="inputfields">
                      <Typography>Additional Status</Typography>
                      <Select
                        name="additionalStatus"
                        value={formData.additionalStatus}
                        onChange={handleInputChange}
                        disabled={loading}
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            borderRadius: "10px",
                            top: "2px",
                          },
                          "& .MuiOutlinedInput-notchedOutline": {
                            borderRadius: "10px",
                            height: "45px",
                          },
                          "& .MuiSelect-icon": {
                            top: "8px",
                            color: "blue",
                          },
                          "& .MuiOutlinedInput-input": {
                            paddingTop: "9px",
                          },
                        }}
                      >

                        <MenuItem value="Go">Go</MenuItem>
                        <MenuItem value="No Go">No Go</MenuItem>
                      </Select>
                    </FormControl>
                  </Col>

                </Row>
                <Row>

                  <Col lg={12} md={12} sm={12} xs={12}>
                    <FormControl fullWidth margin="normal" className="inputfields">
                      <Typography>Conference Information</Typography>
                      <TextField
                        name="conferenceInformation"
                        autoComplete="off"
                        value={formData.conferenceInformation}
                        onChange={handleInputChange}
                        placeholder="Conference Information"
                        variant="outlined"
                        fullWidth
                        multiline
                        minRows={1}
                        disabled={loading}
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            borderRadius: "10px",
                          },
                          "& .MuiInputBase-root": {
                            height: "auto",
                          },
                        }}
                      />
                      {errors.conferenceInformation && (
                        <Typography color="error" sx={{ fontSize: "0.75rem" }}>
                          {errors.conferenceInformation}
                        </Typography>
                      )}
                    </FormControl>
                  </Col>


                </Row>

              </Box>
              <Box
                sx={{
                  border: "1px solid #ccc",
                  borderRadius: "10px",
                  padding: "16px",

                  position: "relative",
                }}
              >
                <Typography
                  sx={{
                    position: "absolute",
                    top: "-10px",
                    left: "20px",
                    background: "#fff",
                    padding: "0 8px",
                    fontSize: "14px",
                    fontWeight: "bold",
                  }}
                >
                  Additional Details
                </Typography>
                <Row>
                  <Col lg={12} md={12} sm={12} xs={12}>
                    <FormControl fullWidth margin="normal" className="inputfields">
                      <Typography>Comments</Typography>
                      <TextField
                        placeholder="Comments"
                        autoComplete="off"
                        name="comments"
                        value={comments}
                        multiline
                        minRows={1}
                        disabled={loading}
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            borderRadius: "10px",
                          },
                          "& .MuiInputBase-root": {
                            height: "auto",
                          },
                        }}
                        onChange={(e) => setComments(e.target.value)}
                      />
                      {errors.comments && (
                        <Typography color="error">{errors.comments}</Typography>
                      )}
                    </FormControl>
                  </Col>
                </Row>
              </Box>
              <Row className="d-flex justify-content-center">
                <Col lg={3}></Col>
                <Col lg={9}>
                  <Box display="flex" justifyContent="end">
                    <Button
                      variant="contained"
                      sx={{ marginTop: 2 }}
                      disabled={!isFormValid || loading}
                      onClick={handleSave}
                      className={` text-capitalize rounded-3 ${isFormValid && !loading ? "button-enabled" : "button-disabled"}`}
                    >
                      {loading ? 'Saving...' : 'Save'}
                    </Button>
                  </Box>
                </Col>
              </Row>
            </Container>
          </form>
        </Box>
      </Card>

    </Container>
  );
}